import { authMMOClient } from 'common/data/authentication/reducer'
import { Store, AnyAction } from 'redux'
import { AppState } from 'common/store'

export function determineMMOClientAccess(
    contentApiBaseUrl: string,
    isFeatureEnabled: boolean,
    store: Store<AppState, AnyAction>
) {
    const referrer = typeof document !== 'undefined' && document.referrer
    const isValidReferrer = referrer && referrer.indexOf(`${contentApiBaseUrl}/csp?target=`) !== -1

    if (isFeatureEnabled && isValidReferrer) {
        const slug = document.location.pathname.substr(
            document.location.pathname.lastIndexOf('/') + 1
        )
        store.dispatch(authMMOClient({ mmoArticleSlug: slug }))
    }
}
